import { FormLayout, usePDFPrintHook } from "@careinfo/layout";
import { useFieldArray, useForm } from "react-hook-form";
import Form from "./Form";
import { tw } from "@careinfo/tailwind";
import Card from "../Reusable/Card";
import Button from "../Reusable/Button";
import Modal from "../Reusable/Modal";
import { getKey } from "../../helpers/sessionKey";

const CreateExpenseNote = (props: any) => {
  const {
    handleCreate,
    isLoading,
    defaultBranch,
    setOpenPrintPopup,
    openPrintPopup,
    handleSlipPrint,
    data,
    isPrintLoading,
  } = props;
  const defaultBranchParseValue = JSON.parse(defaultBranch);
  const {
    control,
    register,
    handleSubmit,
    getValues,
    reset,
    watch,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: async () => {
      return {
        from_branch: defaultBranchParseValue,
        destination: null,
        ship_via: data?.[0],
        items: [
          {
            product_type: null,
            destination: null,
            weight: 0,
            piece: 1,
            description: null,
            amount: 0,
          },
        ],
      };
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const handleClosePrintPopup = () => {
    setOpenPrintPopup(false);
    reset({
      from_branch: defaultBranchParseValue,
      destination: null,
      ship_via: data?.[0],
      items: [
        {
          product_type: null,
          destination: null,
          weight: 0,
          piece: 1,
          description: null,
          amount: 0,
        },
      ],
    });
  };
  const isSuperUser = getKey("is_superuser") === "true";
  return (
    <>
      <Card>
        <form
          className={tw``}
          onSubmit={handleSubmit((data) => handleCreate(data, false, setError))}
        >
          <Form
            errors={errors}
            register={register}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            fields={fields}
            isSuperUser={isSuperUser}
            watch={watch}
            remove={remove}
            append={append}
          />
          <div className={tw`flex justify-end w-full gap-x-4 px-4`}>
            <div className={tw`w-24`}>
              <Button
                onClick={handleSubmit((data) =>
                  handleCreate(data, true, setError)
                )}
                type="button"
                isLoading={isLoading}
                label={"Create & Print"}
              />
            </div>
            <div className={tw`w-24`}>
              <Button label={"Create"} isLoading={isLoading} />
            </div>
          </div>
        </form>
      </Card>
      <Modal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrintPopup}
        title={"Print "}
      >
        <form action="#" className={tw`w-[600px]`}>
          <Button
            label={"Print Slip"}
            type="button"
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handleSlipPrint}
            autoFocus
          />
          <Button
            type="button"
            label={"Close"}
            onClick={handleClosePrintPopup}
          />
        </form>
      </Modal>
    </>
  );
};

export default CreateExpenseNote;
